import * as React from 'react';
import { IBaseQuestionProps } from '../../FormContainer/types/internal';
import { useFormTracking } from '../../../utils/useFormTracking';

export const useHandleSelect = (params: IBaseQuestionProps) => {
  const {
    question: { answerField },
    setAnswer,
    answersState,
    setNextStep,
  } = params;

  const { trackSubmit, trackWantToChooseRealtorEvent } = useFormTracking();

  return React.useCallback(
    (value: string) => {
      const answer = {
        answerField,
        value,
      };

      const nextAnswersState = {
        ...answersState,
        [answerField]: answer,
      };

      setAnswer(answer);
      setNextStep(nextAnswersState);
      trackSubmit({
        isRequired: true,
        field: answerField,
        value,
      });
      if (answerField === 'wantToChooseRealtor') {
        trackWantToChooseRealtorEvent(value);
      }
    },
    [answerField, answersState, setAnswer, setNextStep, trackSubmit, trackWantToChooseRealtorEvent],
  );
};
